import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { startTelemetry } from "./lib/telemetry";
import { startAnalytics } from "./lib/analytics";
import { installStaleChunkReload } from "./lib/staleChunk";
import { bootstrapBranding } from "./lib/branding";
import "./index.css";

// Before render, deliberately: the document-load instrumentation needs to be
// registered while the navigation timings are still available, and the XHR
// patch has to be in place before React's first effect fires an API call.
// It is a no-op unless VITE_OTEL_EXPORTER_URL is set, and it never throws.
startTelemetry();

// GA4. A no-op unless VITE_GA_MEASUREMENT_ID is set, and it never throws.
startAnalytics();

// A tab opened before a deploy reloads itself instead of crashing on the
// first page whose old chunk is gone.
installStaleChunkReload();

// Tenant white labeling: title, favicon and brand colours for this hostname
// (cached copy first, then the live one) - see lib/branding.
bootstrapBranding();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
